export const DEFAULT_THUMBNAIL =
  'https://assets1.cleartax-cdn.com/cleartax/images/1675336611_dummy_webinar_thumbnail.png';

export enum EVENT_TYPE {
  UPCOMING = 'upcoming',
  PAST = 'past',
}

export const SORT_BY = {
  ASCENDING: 'airing_at',
  DESCENDING: '-airing_at',
};

export const PAST_NOT_FOUND_ERROR =
  'We are sorry. No past webinars found that match your search conditions. You can try modifying your product filter or the search terms.';

export const UPCOMING_NOT_FOUND_ERROR =
  'We are sorry. No upcoming webinars are available. You can explore our past webinars in the section below.';

export const DEFAULT_VIEW_MORE_LIMIT = 12;
